import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileDialogComponent } from '../../dialogs/upload-file-dialog/upload-file-dialog.component';
import { DocumentConstants } from 'app/constants/document.constants';
import { FormService } from 'app/services/form.service';
import { AttachmentModel } from 'app/models/attachment.model';

@Component({
  selector: 'app-pegylated-nucleic-acid-based-substances',
  templateUrl: './pegylated-nucleic-acid-based-substances.component.html',
  styleUrls: ['./pegylated-nucleic-acid-based-substances.component.scss']
})
export class PegylatedNucleicAcidBasedSubstancesComponent {
  fileUploaded = false;
  readonly dialog = inject(MatDialog);

  constructor(protected formService: FormService) {}

  public openDialog(): void {
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      data: {
        fileName: this.documentPrefix
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.fileUploaded = true;
      }
    });
  }

  get attachments(): AttachmentModel[] {
    const type = this.documentPrefix;
    
    if(!type) {
      return [];
    }

    return this.formService.allAttachmentsForSection(type);
  }
  
  get documentPrefix(): string {
    if(this.isFormBType) {
      return DocumentConstants.PEGYLATED_PROTEINS_AND_PEPTIDES;
    }

    if(this.isFormDType) {
      return DocumentConstants.ALL_PEGYLATED_SUBSTANCES;
    }

    if(this.isFormFType) {
      return DocumentConstants.PEGYLATED_NUCLEIC_ACID_BASED_SUBSTANCES;
    }

    return '';
  }

  get title(): string {
    if(this.isFormBType) {
      return 'Pegylated Proteins and Peptides';
    }

    if(this.isFormDType) {
      return 'All Pegylated Substances';
    }

    if(this.isFormFType) {
      return "For pegylated nucleic acid-based substances"
    }

    return '';
  }

  get infoText(): string {
    let text = '';
    if(this.isFormBType) {
      text += `<ul>\
        <li>The details of pegylation: the end group and the polymer chain with the average number of repeat units (to 2 significant figures)</li>\
        <li>The details of the linker (not the reagent used); where the linker is attached the moiety, and, ideally, if multiple sites are involved, in 
        what proportion they are modified</li>\
        </ul>`;
    }

    if(this.isFormDType) {
      text += `Details of pegylation: end group, polymer chain with average number of repeat units to 2 significant figures, details of the linker (not 
      the reagent used), point of attachment of the linker to the active moiety, and, ideally, if multiple sites are involved, in what proportion they are 
      modified`;
    }

    if(this.isFormFType) {
      text += `<ul>\
        <li>The details of pegylation: the end group and the polymer chain with the average number of repeat units (to 2 significant figures).</li>\
        <li>The details of the linker (not the reagent used): where the linker is attached to the active moiety, and, ideally, if multiple sites are 
        involved, in what proportion they are modified. For conjugated nucleic acid-based substances: The mean numbers of molecules of the conjugated part, 
        and if known, positions where the conjugate is attached.</li>\
        </ul>`;
    }

    return text;
  }

  get buttonText(): string {
    if(this.isFormBType) {
      return 'Upload Pegylated Proteins and Peptides';
    }

    if(this.isFormDType) {
      return 'Upload All Pegylated Substances';
    }

    if(this.isFormFType) {
      return 'Upload Pegylated Nucleic Acid-based Substances';
    }

    return 'Upload';
  }


  get wasFileUploaded(): boolean {
    return this.fileUploaded;
  }

  get formType(): string {
    return this.formService.getCurrentUsanFormType();
  }
  
  get isFormAType(): boolean {
    return 'FormA' === this.formType;
  }

  get isFormBType(): boolean {
    return 'FormB' === this.formType;
  }

  get isFormCType(): boolean {
    return 'FormC' === this.formType;
  }

  get isFormDType(): boolean {
    return 'FormD' === this.formType;
  }

  get isFormEType(): boolean {
    return 'FormE' === this.formType;
  }

  get isFormFType(): boolean {
    return 'FormF' === this.formType;
  }
}
